import React, { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import HistoryPage from "pages/history/HistoryPage";

import QuotesPage from "pages/quotes";
import SettingsPage from "./pages/settings/SettingsPage";
import RequireAuth from "./hoc/RequireAuth";
import AuthPage from "./pages/auth/AuthPage";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import RobotsList from "components/RobotsList/RobotsList";
import { changeTickerBlockStatus } from "store/reducers/SettingsSlice";

export const logout = async () => {
    Cookies.remove("access");
};

const pages = [
    {
        path: "",
        element: <Navigate to="/quotes" />,
    },
    {
        path: "quotes",
        element: <QuotesPage />,
    },
    {
        path: "settings",
        element: <SettingsPage />,
    },
    {
        path: "calculations",
        element: <HistoryPage />,
    },
];

const Main = () => {
    const UIBlock = useAppSelector((store) => store.logs.uiBlock);
    const selectedRobotId = useAppSelector((state) => state.robots.selectedRobotId);
        const dispatch = useAppDispatch();
    const location = useLocation();

    const previousPathRef = useRef(location.pathname);
        const {
        activeTicker,
        activeGroup,
        error,
    } = useAppSelector((state) => state.settings);

    const tickerRef = useRef({
        ticker: activeTicker.name,
        group: activeGroup.name,
        error,
    });


    useEffect(() => {
        tickerRef.current = {
            ticker: activeTicker.name,
            group: activeGroup.name,
            error,
        };
    }, [activeTicker.name, activeGroup.name, error]);
        useEffect(() => {
        const previousPath = previousPathRef.current;
        const currentPath = location.pathname;

        const {
            ticker,
            group,
            error: tickerError,
        } = tickerRef.current;

        const hasTicker =
            ticker &&
            ticker !== "Название тикера" &&
            tickerError === null;

        if (hasTicker) {
            // Котировки -> Настройки
            if (
                previousPath === "/quotes" &&
                currentPath === "/settings"
            ) {
                dispatch(
                    (changeTickerBlockStatus({
                        blockIt: true,
                        group,
                        ticker,
                    })as any),
                );
            }

            // Настройки -> Котировки
            if (
                previousPath === "/settings" &&
                currentPath === "/quotes"
            ) {
                dispatch(
                    (changeTickerBlockStatus({
                        blockIt: false,
                        group,
                        ticker,
                    }) as any),
                );
            }
        }

        previousPathRef.current = currentPath;
    }, [location.pathname, dispatch]);
    return (
        <>
            <div>
                {UIBlock === "full" && (
                    <div
                        style={{
                            width: "10px",
                            backgroundColor: "#eb1919ff",
                            height: "10px",
                            position: "absolute",
                            top: 10,
                            borderRadius: "50%",
                            left: "70px",
                        }}
                    ></div>
                )}
                <RobotsList />
            </div>
            <Routes>
                {pages.map(({ path, element }) => (
                    <Route
                        index={path === "quotes"}
                        key={path+selectedRobotId}
                        path={path}
                        element={<RequireAuth>{element}</RequireAuth>}
                    />
                ))}
                <Route path="login" element={<AuthPage />} />
            </Routes>
        </>
    );
};

export default Main;
